// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2M5ju","consentsList":"PatientConsents_consentsList__1qJS_","consentsListEmpty":"PatientConsents_consentsListEmpty__3dW4y"};